import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Icon } from '@pella/sash-framework';
import { Image } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const ProjectGallery = ({ heading, images, className, onImageClick, ...other }) => {
	const [loadMore, setLoadMore] = useState(false);

	const onLoadMoreClick = () => setLoadMore(true);

	return (
		<div
			className={`projectGallery bg-neutral-50 py-8 md:py-10 xl:py-12 ${className || ''}`}
			data-testid='project-gallery'
			{...other}
		>
			<Container>
				{heading && <h2 className='text-h3 mb-4 md:mb-2'>{heading}</h2>}
				<p className='text-caption mb-4 md:mb-2'>Click to view the full sized images in the project gallery.</p>

				<div className='grid grid-cols-2 gap-4 md:grid-cols-4 xl:grid-cols-6'>
					{images?.map((img, index) => {
						const imageData = isValidArray(img) ? img[1] : img;

						return (
							<div
								key={index}
								className={`${index > 11 && !loadMore ? 'hidden' : ''}`}
							>
								<button
									onClick={() => onImageClick(imageData?.image?.url)}
									className='group relative block w-full'
									aria-label='View Image'
								>
									<Image
										data={{ image: { url: imageData?.image?.url } }}
										className='block aspect-square w-full object-cover'
									/>

									<span className='text-button absolute left-0 top-0 z-3 h-full w-full bg-gradient-to-t from-transparent to-black/20 py-3 text-center text-white opacity-0 transition-opacity group-hover:opacity-100'>
										<span className='flex items-center justify-center gap-x-2.5'>
											<Icon
												name='zoom_out_map'
												size={16}
											/>
											<span className='underline decoration-white decoration-2 underline-offset-4'>Expand Image</span>
										</span>
									</span>
								</button>
							</div>
						);
					})}
				</div>

				{!loadMore && images?.length > 12 && (
					<Button
						color='primary-alt'
						onClick={onLoadMoreClick}
						className='mt-8'
						wide
					>
						View Additional Images
					</Button>
				)}
			</Container>
		</div>
	);
};

ProjectGallery.propTypes = {
	heading: PropTypes.string,
	images: PropTypes.array,
	className: PropTypes.string,
	onImageClick: PropTypes.func,
};

export default ProjectGallery;
